"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "sourceDeleted", {
  enumerable: true,
  get: function get() {
    return _sourceDeleted["default"];
  }
});
var _sourceDeleted = _interopRequireDefault(require("./sourceDeleted"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }